import { createApp } from 'vue';
import { loadFromGlobal } from '@/lib/calculationparams';
import App from './App.vue';
import './styles/index.scss';

loadFromGlobal();
createApp(App).mount('#nvschade-vue-calculator');
